import React, { useState } from 'react'
import ReactDatePicker from 'react-datepicker'
import styled from 'styled-components'

const MonthYearWrap = styled.div`
    width: 100%;

    .react-datepicker-wrapper {
        display: block;
        width: 100%;
    }

    .react-datepicker__input-container {
        display: block;
        width: 100%;
    }

    .react-datepicker-popper {
        z-index: 2002 !important;
    }

    &.clndr-floating .react-datepicker-popper {
        z-index: 2003 !important;
    }

    .react-datepicker {
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
        font-family: inherit;
    }

    .react-datepicker__header {
        background: #f8fafc;
        border-bottom: 1px solid #e2e8f0;
    }

    .react-datepicker__month-text {
        padding: 8px 12px;
        border-radius: 6px;
    }

    .react-datepicker__month-text--selected,
    .react-datepicker__month-text--keyboard-selected {
        background: #2563eb !important;
        color: #fff !important;
    }

    .month-year-trigger {
        width: 100%;
        padding: 0.67857143em 1em;
        border: 1px solid rgba(34, 36, 38, 0.15);
        border-radius: 0.28571429rem;
        background: #fff;
        text-align: left;
        cursor: pointer;
        min-height: 38px;
        font-size: 1em;
        line-height: 1.21428571em;
        color: rgba(0, 0, 0, 0.87);
    }

    .month-year-trigger:focus {
        outline: none;
        border-color: #85b7d9;
    }

    &.clndr-floating {
        position: relative;
        z-index: 2000;
    }

    &.compact .month-year-trigger {
        min-height: 34px;
        padding: 0 12px;
        font-size: 13px;
        border: 1px solid #dde2f0;
        border-radius: 7px;
        color: #1a2744;
    }
`

const MonthYearTrigger = React.forwardRef(({ value, onClick, disabled }, ref) => (
    <button
        type="button"
        className="month-year-trigger"
        onClick={onClick}
        ref={ref}
        disabled={disabled}
    >
        {value || 'Select month and year'}
    </button>
))

MonthYearTrigger.displayName = 'MonthYearTrigger'

export const MonthYearPicker = ({
    month,
    year,
    onChange,
    label,
    disabled = false,
    compact = false,
    placeholder = 'Select month and year',
}) => {
    const [calendarOpen, setCalendarOpen] = useState(false)

    const selectedDate = month && year ? new Date(year, month - 1, 1) : null

    const displayLabel = selectedDate
        ? selectedDate.toLocaleDateString('en-US', {
              month: 'long',
              year: 'numeric',
          })
        : ''

    return (
        <MonthYearWrap
            className={`${calendarOpen ? 'clndr-floating' : ''} ${compact ? 'compact' : ''}`.trim()}
        >
            {label && (
                <label
                    style={{
                        display: 'block',
                        fontSize: compact ? '12px' : undefined,
                        fontWeight: compact ? 600 : undefined,
                        color: compact ? '#1a2744' : undefined,
                        marginBottom: compact ? '6px' : undefined,
                    }}
                >
                    {label}
                </label>
            )}
            <ReactDatePicker
                selected={selectedDate}
                onChange={date => {
                    if (!date) return
                    onChange?.(date.getMonth() + 1, date.getFullYear())
                }}
                showMonthYearPicker
                dateFormat="MMMM yyyy"
                customInput={
                    <MonthYearTrigger
                        value={displayLabel || placeholder}
                        disabled={disabled}
                    />
                }
                disabled={disabled}
                yearDropdownItemNumber={15}
                scrollableYearDropdown
                popperPlacement="bottom-start"
                popperClassName="month-year-popper"
                popperModifiers={[
                    {
                        name: 'flip',
                        enabled: false,
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            rootBoundary: 'viewport',
                            tether: false,
                            altAxis: true,
                        },
                    },
                ]}
                onCalendarOpen={() => setCalendarOpen(true)}
                onCalendarClose={() => setCalendarOpen(false)}
            />
        </MonthYearWrap>
    )
}
